import { makeObservable } from 'mobx';
import isEmpty from 'lodash/isEmpty';

import type { EntryDrugParams } from 'chaika-frontend-types/frontend-cms';

import { List } from '@store/abstract/List';
import { DateHelper } from '@utils/DateHelper';

import { EntryDrug } from './EntryDrug';

export interface DrugFilterParams {
    isNotDeleted: boolean;
    endDate: Date;
}

export class EntryDrugList extends List<EntryDrug, EntryDrugParams, DrugFilterParams> {
    constructor(drugs: EntryDrugParams[]) {
        super();
        makeObservable(this);

        this.filterParams = {
            endDate: new Date(),
            isNotDeleted: true,
        };

        this.set(drugs || []);
    }

    public serialize(): EntryDrugParams[] {
        const drugs: EntryDrugParams[] = [];

        this.list.forEach(drug => {
            drugs.push(drug.serialize());
        });

        return drugs;
    }

    protected create(params: EntryDrugParams): EntryDrug {
        return new EntryDrug(params);
    }

    protected filterValue(drug: EntryDrug, filterParams: DrugFilterParams): boolean {
        const filterByEndDate = !isEmpty(drug.endDate) ? DateHelper.isBefore(filterParams.endDate, drug.endDate) : true;
        const filterByStatus = filterParams.isNotDeleted ? !drug.isDeleted : true;

        return filterByEndDate && filterByStatus;
    }
}
